import { render, staticRenderFns } from "./UserAccountPurchasesManageTopUps.vue?vue&type=template&id=b32cbe46&"
import script from "./UserAccountPurchasesManageTopUps.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchasesManageTopUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports